<div class="listing-contact">
  <a
    #clickThroughEl
    [attr.href]="primaryAgent.profile_url"
    target="_blank"
    class="agent-card d-flex flex-sm-column flex-md-row justify-content-between align-items-center p-3 pr-2"
  >
    <div class="profile-picture-container">
      <img
        class="profile-picture"
        [src]="primaryAgent.avatar_url || 'assets/ProfilePlaceholder.gif'"
        [alt]="primaryAgent.first_name + ' ' + primaryAgent.last_name + '\'s profile picture'"
      >
    </div>
    <div class="agent-name-container ml-1 ml-sm-0 ml-md-1">
      <div>MEET&nbsp;<span class="agent-name">{{primaryAgent.first_name | uppercase }}</span>,</div>
      <div>THE LISTING AGENT</div>
    </div>
  </a>

  <div class="agent-contact contact-form p-3">
    <form
      #listingInquiryForm="ngForm"
      (ngSubmit)="onSubmit()"
    >
      <label for="lead-question">Ask Them a Question</label>
      <textarea
        id="lead-question"
        [(ngModel)]="listingInquiry.question"
        name="question"
        class="w-100 form-control"
        rows="3"
      ></textarea>
      <div>
        <label
          for="lead-email"
          class="mt-2 form-control-label"
        >Include Your Email Address</label>
        <input
          id="lead-email"
          [(ngModel)]="listingInquiry.emailAddress"
          (ngModelChange)="validateEmailOnChange($event)"
          name="email"
          class="w-100 form-control"
          [class.is-invalid]="listingInquiryForm.submitted && displayEmailInvalid"
        >
      </div>
      <button
        type="submit"
        class="d-block btn btn-primary mt-3 mr-0 ml-auto"
      >Submit Your Inquiry</button>
    </form>
  </div>
  <a
    #clickThroughEl
    textCta
    class="agent-contact phone-link d-flex justify-content-center align-items-center py-2 px-3"
    href="tel:1-267-463-5995"
  >
    <fa
    flattenBefore
      name="phone-alt"
      class="phone-icon"
    ></fa><span flattenBefore>&nbsp;</span>1-267-463-5995
  </a>

</div>
